var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M846 726L846 754",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 846.5,
    cy: 721.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M841.987 721.19C841.987 717.283 845.288 714.117 849.358 714.117C849.943 714.117 850.511 714.184 851.056 714.308C849.742 713.48 848.187 713 846.519 713C841.814 713 838 716.806 838 721.5C838 726.194 841.814 730 846.519 730C848.814 730 850.895 729.093 852.427 727.62C851.492 728.032 850.454 728.263 849.358 728.263C845.288 728.263 841.987 725.096 841.987 721.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M855.402 720.6L855.37 718.146L853.535 719.719L851.304 719.056L852.112 721.337L850.765 723.381L853.1 723.218L854.499 725.144L855.133 722.763L857.345 721.909L855.402 720.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch3);
export default __webpack_public_path__ + "static/media/church_3.75ab5962654b3b78268e37f415f83b8e.svg";
export { ForwardRef as ReactComponent };